var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-solid:check-one"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7783_70809",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 14,
    height: 13
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00131 13.3327C7.7675 13.3337 8.52633 13.1832 9.23419 12.89C9.94206 12.5968 10.585 12.1666 11.1261 11.6241C11.6685 11.083 12.0988 10.4401 12.392 9.73224C12.6852 9.02438 12.8356 8.26554 12.8346 7.49935C12.8356 6.73317 12.6852 5.97434 12.392 5.26648C12.0987 4.55862 11.6685 3.91568 11.1261 3.3746C10.585 2.83211 9.94206 2.4019 9.23419 2.10868C8.52633 1.81546 7.7675 1.66503 7.00131 1.66602C6.23512 1.66504 5.47629 1.81549 4.76843 2.1087C4.06057 2.40192 3.41763 2.83212 2.87656 3.3746C2.33408 3.91568 1.90387 4.55862 1.61065 5.26648C1.31744 5.97434 1.167 6.73317 1.16797 7.49935C1.16698 8.26554 1.31742 9.02438 1.61063 9.73224C1.90385 10.4401 2.33406 11.083 2.87656 11.6241C3.41763 12.1666 4.06057 12.5968 4.76843 12.89C5.47629 13.1832 6.23512 13.3337 7.00131 13.3327Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.66797 7.5L6.41797 9.25L9.91797 5.75",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7783_70809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 0.5H14V14.5H0V0.5Z",
    fill: "#3BB56C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketPaid);
export default __webpack_public_path__ + "static/media/ticket-paid.b963ad39a20d2b0aee7e9627e0d3770a.svg";
export { ForwardRef as ReactComponent };